import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Logger, GlobalInfoService } from '@app/core';
import {
  Context,
  DynamicComponentForm,
  Tarea,
  Const,
} from '@app/shared';

const log = new Logger('AssignmentFormComponent');

/**
 * Interface de datos de la tabla de historial de asignaciones
 *
 * @export
 * @interface HistoryAssignment
 */
export interface HistoryAssignment {
  fecha_registro?: string;
  fecha_finalizacion: string;
  responsable: string;
  usuarios_asignados: string;
  fecha_rechazo: string;
  descripcion: string;
  responsable_rechazo: string;
}

@Component({
  selector: 'iw-assignment-form',
  templateUrl: './assignment-form.component.html',
  styleUrls: ['./assignment-form.component.scss']
})
export class AssignmentFormComponent extends DynamicComponentForm implements OnInit {
  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<any>;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Define si la tarea esta finalizada
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // Tarea siguiente
  nextTask: Tarea;

  constructor(
    private gis: GlobalInfoService
  ) {
    super();
  }

  ngOnInit() {
    if(this.previewFlow){
      this.finishTask = true;
    }
    if (
      this.ctx.task &&
      this.ctx.task.tarea_estado &&
      this.ctx.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.ctx.task &&
      this.ctx.task.tarea_estado &&
      this.ctx.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }
    // Consultar información global
    this.gis.get().subscribe(global => {
      // Consultar tarea siguiente a la actual
      const nextTask = this.getNextTask(global, this.ctx.task);
      if (nextTask) {
        this.nextTask = nextTask;
      }
    });
  }
} // End class



// WEBPACK FOOTER //
// ./src/app/forms/all/assignment-form/assignment-form.component.ts